<script>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import EditMarketPlaceProductModal from '@/components/price-managment/modals/EditMarketPlaceProduct.vue'
import EditVariantModal from '@/components/price-managment/modals/EditVariant.vue'

import {
    getLinkedMarketPlaceProductRequest,
    setLinkedMarketPlaceProductRequest,
    setProductStatusRequest,
    setVariantRequest,
    getVariantRequest
} from "@/api/product";

DataTable.use(DataTablesCore);

export default {
    props: { locale: null, filtersData: null },
    components: { DataTable, EditMarketPlaceProductModal, EditVariantModal },
    data() {

        return {
            showLoading: false,
            products: null,
            variant: null,
            linkedMarketPlaceProduct: null,
            search: null
        };
    },
    mounted() {
        this.$i18n.locale = this.locale
        const locale = this.locale
        const getLinkedMarketPlaceProduct = this.getLinkedMarketPlaceProduct;
        const getVariant = this.getVariant;
        const switchProduct = this.switchProduct;
        const switchLinkedProduct = this.switchLinkedProduct;
        const switchVariant = this.switchVariant;
        const appUrl = process.env.MIX_API_URL
        const productEditUrl = window.location.origin + '/' + this.locale + '/products/update/';
        const langFile = (locale == 'ar') ? "Arabic.json" : "English.json"
        $(() => {
            var dt = $('#products_table').DataTable({
                serverSide: true,
                "searching": true,
                paging: true,
                "language": {
                    "url": window.location.origin + "/" + langFile
                },
                pagingType: "simple_numbers",
                ajax: {
                    url: appUrl + 'products',
                    data: function (datatable) {
                        datatable.filter = $('#datatable_filter').serializeJSON();
                        return datatable;
                    },
                    headers: {
                        "locale": locale
                    }
                },
                columns: [
                    {
                        className: "dt-control min-w-40px ",
                        orderable: false,
                        data: null,
                        defaultContent: "",
                        render: function (data) {
                            // if (data.linked_marketplace_products.length == 0)
                            //     return '';
                            return `<div class="icons-container">
                            <div class="plus-icon-container">
                                <img src="${window.location.origin}/assets/image/plus-icon.svg" />
                            </div>

                            <div class="minus-icon-container">
                                <img src="${window.location.origin}/assets/image/minus-icon.svg" />
                            </div>

                            </div>
                            `;
                        },
                    },
                    {
                        data: null, title: this.$t('product'),
                        defaultContent: "-",
                        width: "20%",
                        render: function (data, type, row) {
                            return '<p><img class="thumb-img" src="' + data.Thumbnail + '" /> ' + data.available_name + '</p>'
                        }
                    },
                    {
                        data: "sku", title: this.$t('sku'),
                        defaultContent: "-"
                    },
                    {
                        data: "category.available_name", title: this.$t('category'),
                        defaultContent: "-"
                    },
                    {
                        data: null,
                        orderable: false,
                        title: this.$t('marketPlaces'),
                        render: function (data) {
                            let logos = [];
                            let images = '';
                            if (data.linked_marketplace_products.length == 0)
                                return '-';
                            data.linked_marketplace_products.forEach(element => {
                                if (element.marketplace.logo_url != '' && !logos.includes(element.marketplace.logo_url)) {
                                    logos.push(element.marketplace.logo_url);
                                }
                            });

                            logos.forEach(logo => {
                                images += '<img src="' + logo + '" class="market-place-logo" />'
                            })
                            return images;
                        },
                    },
                    {
                        data: "manufacturer.available_name", title: this.$t('manufacturer'),
                        defaultContent: "-"
                    },
                    {
                        data: null,
                        orderable: false,
                        title: this.$t('available'),

                        render: function (data) {
                            return `<td><div class="form-check form-switch">
                            <input  ${(data.disabled_at == null ? 'checked' : '')} data-id="${data.id}" class="form-check-input product-switch" type="checkbox" role="switch" id="product_${data.id}">
                            </div></td>`;
                        },
                    },
                    {
                        data: null,
                        orderable: false,
                        title: this.$t('actions'),
                        // className: "w-20px text-end",
                        render: function (data) {
                            return '<a target="blank" href="' + productEditUrl + data.id + '" class="edit-btn" data-id="' + data.id + '" ><img data-id="' + data.id + '" src="' + window.location.origin + '/assets/image/edit-btn.svg" /></a>';
                        },
                    },
                ],
                columnDefs: [{
                    targets: 0,
                    render: function (data, type, row) {
                        return data.substr(0, 15);
                    }
                }]

            });

            window.table = dt
            const filterSearch = document.querySelector('[data-kt-docs-table-filter="product-search"]');
            filterSearch.addEventListener('keyup', function (e) {
                dt.search(e.target.value).draw();
            });

            dt.on('draw', function () {
                $('.product-switch').on('change', function (e) {

                    const id = this.getAttribute('data-id')
                    const status = (this.checked) ? 'enable' : 'disable'
                    switchProduct(id, status)

                })
            })

            dt.on('click', 'td.dt-control', (e) => {
                let tr = e.target.closest('tr');
                let row = dt.row(tr);

                if (row.child.isShown()) {
                    // This row is already open - close it
                    row.child.hide();
                }
                else {


                    var text = '';
                    if (row.data().linked_marketplace_products.length > 0) {
                        text =
                            '<div class="table-responsive"><table class="table sub-table"><thead><tr><th>' + this.$t('productNumber') + '</th><th>' + this.$t('identifierType') + '</th><th>' + this.$t('identifierValue') + '</th>';
                        var counter = 1;
                        row.data().linked_marketplace_products[0].variant.option_values.forEach(op => {
                            text += '<th>' + this.$t('option') + ' ' + counter + '</th>'
                            counter++;
                        })
                        text += '<th>' + this.$t('marketPlaces') + '</th><th>' + this.$t('quantity') + '</th><th>' + this.$t('sellingPrice') + '</th><th>' + this.$t('priceAfterDiscount') + '</th><th>' + this.$t('available') + '</th><th>' + this.$t('actions') + '</th></tr></thead><tbody>';
                        row.data().linked_marketplace_products.map((v) => {
                            const identifier_type = (v.identifier_type) ?? '-';
                            const identifier_value = (v.identifier_value) ?? '-';
                            let options = ''
                            const discounted_price = (v.discounted_price == null) ? v.selling_price : v.discounted_price

                            v.variant.option_values.forEach(ov => {
                                if (ov.option == undefined || ov.option?.available_name == null || ov.available_name == null)
                                    options += '<td>-</td>';
                                else
                                    options += `<td><p>${ov.option?.available_name} : ${ov.available_name}</p></td>`
                            }
                            )

                            text +=
                                "<tr><td>" + v.sku + "</td>";
                            text +=
                                "<td>" +
                                identifier_type +
                                "</td>";
                            text +=
                                "<td>" +
                                identifier_value +
                                "</td>";
                            text += options;
                            text +=
                                '<td><img  class="market-place-logo" src="' + v.marketplace.logo_url + '"</td>';
                            text += "<td>" + v.quantity + "</td>";
                            text += "<td>" + v.selling_price + "</td>";
                            text += "<td>" + discounted_price + "</td>";
                            text += `<td><div class="form-check form-switch">
                            <input  data-variant-id="${(v.status == "LISTED") ? v.id : v.variant_id}" data-linked-marketplace-id="${v.linked_marketplace_id}" ${(v.status == "LISTED" ? 'checked' : '')} class="form-check-input linked-product-switch" type="checkbox" role="switch" id="linked-product-switch-${(v.status == "LISTED") ? v.id : v.variant_id}">
                            </div></td>`;
                            text +=
                                '<td><button class="edit-btn" data-bs-toggle="modal" data-id="' + v.id + '" data-bs-target="#edit_marketplace_linked_product" ><img data-id="' + v.id + '" src="' + window.location.origin + '/assets/image/edit-btn.svg" /></button></td></tr>';
                        });
                        text += "</tbody></table> </div>";
                    } else {
                        text =
                            '<div class="table-responsive"><table class="table sub-table"><thead><tr><th>' + this.$t('productNumber') + '</th><th>' + this.$t('identifierType') + '</th><th>' + this.$t('identifierValue') + '</th>';
                        var counter = 1;
                        row.data().variants[0].option_values.forEach(op => {
                            text += '<th>' + this.$t('option') + ' ' + counter + '</th>'
                            counter++;
                        })
                        text += '<th>' + this.$t('marketPlaces') + '</th><th>' + this.$t('quantity') + '</th><th>' + this.$t('sellingPrice') + '</th><th>' + this.$t('priceAfterDiscount') + '</th><th>' + this.$t('available') + '</th><th>' + this.$t('actions') + '</th></tr></thead><tbody>';
                        row.data().variants.map((v) => {
                            const identifier_type = (v.identifier_type) ?? '-';
                            const identifier_value = (v.identifier_value) ?? '-';
                            let options = ''
                            const discounted_price = (v.price_after_discount == null) ? v.price : v.price_after_discount

                            v.option_values.forEach(ov => {
                                if (ov.option == undefined || ov.option?.available_name == null || ov.available_name == null)
                                    options += '<td>-</td>';
                                else
                                    options += `<td><p>${ov.option?.available_name} : ${ov.available_name}</p></td>`
                            }
                            )

                            text +=
                                "<tr><td>" + row.data().sku + "</td>";
                            text +=
                                "<td>" +
                                identifier_type +
                                "</td>";
                            text +=
                                "<td>" +
                                identifier_value +
                                "</td>";
                            text += options;
                            text +=
                                '<td>-</td>';
                            text += "<td>" + v.quantity + "</td>";
                            text += "<td>" + v.price + "</td>";
                            text += "<td>" + discounted_price + "</td>";

                            text += `<td><div class="form-check form-switch">
                            <input  data-variant-id="${v.id}"  ${(v.status == "ACTIVE" ? 'checked' : '')} class="form-check-input variant-switch" type="checkbox" role="switch" id="variant_${v.id}">
                            </div></td>`;

                            text += '<td><button class="edit-variant" data-bs-toggle="modal" data-id="' + v.id + '" data-bs-target="#edit_variant" ><img data-id="' + v.id + '" src="' + window.location.origin + '/assets/image/edit-btn.svg" /></button></td></tr>';

                        });
                        text += "</tbody></table> </div>";
                    }
                    row.child(text).show();
                    $('.edit-btn').on('click', (e) => {
                        getLinkedMarketPlaceProduct(e.target.getAttribute('data-id'))
                    })
                    $('.edit-variant').on('click', (e) => {
                        getVariant(e.target.getAttribute('data-id'))
                    })
                    $('.linked-product-switch').on('change', function (e) {

                        const variant_id = this.getAttribute('data-variant-id')
                        const linked_market_id = this.getAttribute('data-linked-marketplace-id')
                        const status = (this.checked) ? 'enable' : 'disable'

                        switchLinkedProduct(linked_market_id, variant_id, status)

                    })

                    $('.variant-switch').on('change', function (e) {

                        const variant_id = this.getAttribute('data-variant-id')
                        const status = (this.checked) ? 'enable' : 'disable'

                        switchVariant(variant_id, status)

                    })
                }
            });
        })

    },
    watch: {
    },
    methods: {
        switchLinkedProduct(linked_market_id, variant_id, status) {
            this.showLoading = true;
            const params = {
                linked_market_id,
                variant_id
            }

            const btnId = `#linked-product-switch-${variant_id}`
            if (status == 'enable')
                swalConfirmFire(`${process.env.MIX_API_URL}linked_product/${params.linked_market_id}/list_product/${params.variant_id}?api=true`, this.$t('listProduct'), this.$t('generalConfirmationMsg'), btnId);
            else
                swalConfirmFire(`${process.env.MIX_API_URL}linked_product/${params.linked_market_id}/unlist_product/${params.variant_id}?api=true`, this.$t('unlistProduct'), this.$t('generalConfirmationMsg'), btnId);
        }, switchVariant(variant_id, status) {
            this.showLoading = true;
            const data = {
                variant_id,
                status
            }
            const btnId = `#variant_${variant_id}`
            swalConfirmFire(`${process.env.MIX_API_URL}variants/updateStatus/${data.status}/${data.variant_id}?api=true`, '', this.$t('generalConfirmationMsg'), btnId);
        },
        switchProduct(id, status) {
            this.showLoading = true;
            const data = {
                id,
                status
            }

            const btnId = `#product_${id}`
            swalConfirmFire(`${process.env.MIX_API_URL}products/updateStatus/${data.status}/${data.id}?api=true`, '', this.$t('generalConfirmationMsg'), btnId);

        },
        getLinkedMarketPlaceProduct(id) {
            this.$refs.editMarketPlaceProductModal.reset()
            this.linkedMarketPlaceProduct = null
            this.ApiService(getLinkedMarketPlaceProductRequest(id))
                .then(({ data }) => {
                    this.linkedMarketPlaceProduct = data.result
                })
                .finally(() => {
                    this.showLoading = false;
                });
        },
        updateLinkedMarketPlaceProduct(data) {
            this.ApiService(setLinkedMarketPlaceProductRequest(data))
                .then(() => {
                    document.getElementById('close').click();
                    swalToastFire('success');
                })
                .catch(e => {
                    var errArr = []
                    for (const [key, value] of Object.entries(e.response.data.errors)) {
                        errArr.push(value)
                    }
                    swalToastFire('error', this.$t('validationError'), errArr);
                })
                .finally(() => {
                    this.showLoading = false;
                });
        },
        getVariant(id) {
            this.$refs.editVariantModal.reset()
            this.variant = null

            this.ApiService(getVariantRequest(id))
                .then(({ data }) => {
                    this.variant = data.result
                })
                .finally(() => {
                    this.showLoading = false;
                });
        },
        updateVariant(data) {
            this.ApiService(setVariantRequest(data))
                .then((data) => {
                    document.getElementById('close').click();
                    swalToastFire('success');
                })
                .catch(e => {
                    var errArr = []
                    for (const [key, value] of Object.entries(e.response.data.errors)) {
                        errArr.push(value)
                    }
                    swalToastFire('error', this.$t('validationError'), errArr);
                })
                .finally(() => {
                    this.showLoading = false;
                });
        }
    },
};
</script>

<template>
    <!-- <DataTable
        ref="table"
        :columns="columns"
        :data="products"
        id="products_table"
        class="vue-tables"
        :options="{
            searching: false,
            paging: false,
        }"
    >
    </DataTable> -->
    <table id="products_table" class="vue-tables"></table>
    <edit-market-place-product-modal ref="editMarketPlaceProductModal" :linkedMarketplaceProduct="linkedMarketPlaceProduct"
        @handleLinkedMarketplaceProductUpdate="updateLinkedMarketPlaceProduct"></edit-market-place-product-modal>
    <edit-variant-modal ref="editVariantModal" :variant="variant" @handleVariantUpdate="updateVariant"></edit-variant-modal>
</template>
<style>
.vue-tables .plus-icon-container {
    background-color: #fff;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.vue-tables .thumb-img {
    max-width: 50px;
    margin: 0px 10px;
}

.vue-tables .plus-icon {
    fill: rgba(88, 88, 88, 0.9);
}

.vue-tables .minus-icon-container {
    background-color: rgba(236, 85, 47, 0.1);
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: none;
}

.vue-tables .minus-icon {
    fill: #ec552f;
}

.vue-tables .market-place-logo {
    width: 30px;
}

.vue-tables .dt-hasChild .plus-icon-container {
    display: none;
}

.vue-tables .dt-hasChild .minus-icon-container {
    display: block;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.vue-tables .delete-btn,
.vue-tables .edit-btn {
    background-color: #fff;
    border: none;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}

.vue-tables .delete-btn {
    background-color: rgba(236, 85, 47, 0.1);
}

.vue-tables .delete-btn svg {
    fill: rgb(236, 85, 47);
}

.vue-tables tbody tr.odd,
.vue-tables tbody tr.even {
    border-bottom: 2px solid #fff;
}

.vue-tables tbody tr.dt-hasChild {
    border-bottom: none;
}

.vue-tables th,
.vue-tables td {
    padding: 25px 0;
}

.vue-tables .switch {
    display: inline-block;
    position: relative;
    width: 50px;
    height: 25px;
    border-radius: 20px;
    background: #dfd9ea;
    transition: background 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    vertical-align: middle;
    cursor: pointer;
}

.vue-tables .switch::before {
    content: "";
    position: absolute;
    top: 1px;
    left: 2px;
    width: 22px;
    height: 22px;
    background: #fafafa;
    border-radius: 50%;
    transition: left 0.28s cubic-bezier(0.4, 0, 0.2, 1),
        background 0.28s cubic-bezier(0.4, 0, 0.2, 1),
        box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.vue-tables .switch:active::before {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28),
        0 0 0 20px rgba(128, 128, 128, 0.1);
}

.vue-tables input:checked+.switch {
    background: #ec552f;
}

.vue-tables input:checked+.switch::before {
    left: 27px;
    background: #fff;
}

.vue-tables input:checked+.switch:active::before {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), 0 0 0 20px rgba(0, 150, 136, 0.2);
}

.vue-tables td,
.vue-tables th {
    font-size: 12px !important;
}

.vue-tables th {
    text-transform: uppercase;
}

.vue-tables table.sub-table,
.vue-tables .sub-table th,
.vue-tables .sub-table td {
    border: 2px solid #fff;
    border-collapse: collapse;
}

.vue-tables .sub-table th {
    font-weight: bolder;
    font-size: 14px;
    padding-inline-start: 10px;
}

.vue-tables .sub-table td {
    padding-inline-start: 10px;
}

.vue-tables .remove-border-btn {
    border-bottom: none;
}

/* html[dir="rtl"] .paginate_button.page-item.previous {
    transform: rotate(180deg);
} */
</style>
>
